import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_6121_10875)\"><path d=\"M8.12451 3.79688V8.25142H11.3063\" stroke=\"#454342\"></path><path d=\"M1.12451 8.25C1.12451 10.1065 1.86201 11.887 3.17477 13.1998C4.48752 14.5125 6.268 15.25 8.12451 15.25C9.98104 15.25 11.7615 14.5125 13.0743 13.1998C14.387 11.887 15.1245 10.1065 15.1245 8.25C15.1245 6.39349 14.387 4.61301 13.0743 3.30026C11.7615 1.9875 9.98104 1.25 8.12451 1.25C6.268 1.25 4.48752 1.9875 3.17477 3.30026C1.86201 4.61301 1.12451 6.39349 1.12451 8.25Z\" stroke=\"#454342\"></path></g><defs><clipPath id=\"clip0_6121_10875\"><rect width=\"16\" height=\"16\" fill=\"white\" transform=\"translate(0.124512 0.25)\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }